import { useContext } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import Axios from '../../api'
import { ErrorModalContext } from '../../context/errorModalContext'

const useDownloadDocument = (url: string, fileName: string) => {
  const { setShowModal, setErrorMessage } = useContext(ErrorModalContext)
  const { getAccessTokenSilently } = useAuth0()
  const handleDownload = async () => {
    const token = await getAccessTokenSilently()
    try {
      const response = await Axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if( response.data.content) {
        const downloadLink = document.createElement('a')
        downloadLink.href = 'data:' + response.data.mime + ';base64,' + response.data.content
        downloadLink.download = response.data.name
        downloadLink.click()
      }
    } catch (error) {
      setShowModal(true)
      setErrorMessage('Erreur lors du téléchargement.')
    }
  }
  return [handleDownload]
}

export default useDownloadDocument
